import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LockedForUploadMessage.module.scss';

export const LockedForUploadMessage: React.FC = () => {
    const { t } = useTranslation();
    return <div className={styles.lockMessageContainer} >{t('inspection_locked_for_upload')}</div>;
}; 